import src from "IMAGE";
export default { src, width: 721, height: 122, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAGElEQVR42mP4eXvVz/8P1v3Hhj9dXfYJANI1HB8CMUNaAAAAAElFTkSuQmCC"};
